<template>
    <v-container fluid class="pt-0">
        <v-row>
            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
            </v-col>

            <v-col lg="8" md="12" sm="12" xs="12" style="position:relative; top: -60px">
                <v-card>
                    <v-card-text class="px-0 py-0">
                        <div class="embed-container" v-html="video.iframe"></div>
                        <v-card-title>{{ video.date+" - "+video.name }}</v-card-title>
                        <v-card-subtitle>{{ video.description }}</v-card-subtitle>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col lg="4" md="12" sm="12" xs="12" style="position:relative; top: -60px">
                <template v-if="videos.length > 0">
                    <v-card v-for="(record, index) in videos" :key="index" class="mb-3">
                        <v-list-item three-line>
                            <v-list-item-content>
                                <div class="overline mb-4">{{ record.date }}</div>
                                <v-list-item-title class="mb-1">
                                    <strong>
                                        {{ record.name }}
                                    </strong>
                                </v-list-item-title>
                                <v-list-item-subtitle>{{ record.description }}</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-avatar tile size="80">
                                <v-img :src="initial_avatar+record.name+final_avatar"></v-img>
                            </v-list-item-avatar>
                        </v-list-item>
                        <v-card-actions>
                            <v-btn text :href="'/watch/'+record.folio">
                                <v-icon class="mr-3" color="red">mdi-play-circle</v-icon>
                                ver
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </template>
                <template v-else>
                    <v-card>
                        <v-card-text class="text-center">Sin más videos registrados</v-card-text>
                    </v-card>
                </template>
            </v-col>
        </v-row>
    </v-container>
</template>
<style>
    .embed-container {
        position: relative;
        padding-bottom: 56.25%;
        height: 0;
        overflow: hidden;
    }
    .embed-container iframe {
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
    }
</style>
<script>
export default {
    props:['video','videos'],
    data: () => ({
        initial_avatar:"https://ui-avatars.com/api/?name=",
        final_avatar:"&background=random",
    })
}
</script>